import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

import { deleteCharacter } from 'redux/actions';

import Paths from 'paths';

class Character extends Component{

    render() {
        let url = false;
        if(this.props.characterUrl !== undefined) {
            url = this.props.characterUrl.url
        }

        return (
            <div className={'soundbox-grid-bar'}>
                <div className={'soundbox-grid-bar-id'}>
                    <span>{this.props.character.id}</span>
                </div>
                <div className={'soundbox-grid-bar-title'}>
                    <span>{this.props.character.name}</span>
                </div>
                <div className={'soundbox-grid-bar-img'}>
                    <img className={(url ? '' : ' not-found')} src={url ? url : undefined} alt={`sound-character-${this.props.character.id}`} title={`sound-character-${this.props.character.id}`} />
                </div>
                <NavLink className={'soundbox-grid-bar-edit'} to={Paths.PATH_ADMIN_EDIT_CHARACTER.replace(':soundboxId',this.props.soundbox.id).replace(':characterId',this.props.character.id)}><FaEdit /></NavLink>
                <div className={'soundbox-grid-bar-delete'} onClick={() => this.aprooveDelete()}><FaTrash /></div>
            </div>
        )
    }

    aprooveDelete = () => {
        Swal.fire({
            title: `Suppression du personnage ${this.props.character.id}`,
            text: 'Etes vous vraiment sûr ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui !'
        }).then((result) => {
            if (result.value) {
                this.props.deleteCharacter(
                    this.props.soundbox,
                    this.props.character.id
                );
            }
        })
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteCharacter: (soundbox, id) => {
            dispatch(deleteCharacter(soundbox, id))
        }
    }
}

export default connect(null, mapDispatchToProps)(Character);